import * as Api from '@/helpers/restApi'

export default {
  state: {
    Users: [],
    UserForm: [],
    OriginUserForm: [],
    Policies: [],
    UserActions: [],
    AuthenticatedData: [],
    RolesVersionData: []
  },
  getters: {
    getUsers: state => state.Users,
    getUserForm: state => state.UserForm,
    getOriginUserForm: state => state.OriginUserForm,
    getPolicies: state => state.Policies,
    getUserActions: state => state.UserActions,
    getAuthenticatedData: state => state.AuthenticatedData
  },
  mutations: {
    SetUsers (state, val) {
      state.Users = val
    }
  },
  actions: {
    setUsers ({ state, dispatch }) {
      // получение данных для таблицы пользователей
      Api.getApi({
        url: '/Users/GetUsers'
      }, 'users')
        .then((data) => {
          if (data.Succeeded) {
            state.Users = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setPutUserForm ({ state, dispatch }, obj) {
      // отправка формы пользователя при редактировании и создании
      // return не удалять это для async await
      return Api.putApi({
        url: `/Users/PutForm/${obj.Id}`,
        payload: obj
      }, 'users')
        .then((data) => {
          if (data.Succeeded) {
            state.UserForm.Id = data.Data.Id
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setGetUserForm ({ state, dispatch }, id) {
      // получаем форму пользователя при создании нового и редактировании
      Api.getApi({
        url: `/Users/GetForm/${id}`
      }, 'users')
        .then((data) => {
          if (data.Succeeded) {
            state.UserForm = data.Data
            // state.OriginUserForm = { ...data.Data }
            // глубокое копирование оригинального объекта
            state.OriginUserForm = JSON.parse(JSON.stringify(data.Data))
            // state.OriginUserForm = structuredClone(data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteUser ({ dispatch }, id) {
      // удаляет пользователя
      Api.deleteApi({
        url: `/Users/Delete/${id}`
      }, 'users')
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUserActions ({ state, dispatch }, id) {
      // получает данные для treetable (таблица) с историей изменений
      Api.getApi({
        url: `/UserActions/GetUserActions/${id}`
      }, 'users')
        .then((data) => {
          if (data.Succeeded) {
            state.UserActions = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setAuthenticatedData ({ state, dispatch }) {
      // получает данные пользователя для сайтбара и страницы
      // пользователя, а также  массив Policies
      Api.getApi({
        url: '/Users/AuthenticatedData'
      }, 'users')
        .then((data) => {
          if (data.Succeeded) {
            state.AuthenticatedData = data.Data
            state.Policies = data.Data.Policies
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setChangePassword ({ dispatch }, obj) {
      // отправляет старый и новый пароли при смене пароля пользователя
      Api.postApi({
        url: '/Users/ChangePassword',
        payload: obj
      }, 'users')
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setRolesVersionData ({ state, commit, dispatch }, recordId) {
      // получает версию новостей
      Api.getApi({
        url: `/UserActions/GetUserActionInfo/${recordId}`
      }, 'users')
        .then((data) => {
          if (data.Succeeded) {
            state.RolesVersionData = data.Data
            commit('SetNewsForm', data.Data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
